import { render, staticRenderFns } from "./ShippingInput.vue?vue&type=template&id=400ee5a6"
import script from "./ShippingInput.vue?vue&type=script&lang=ts"
export * from "./ShippingInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports